<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Dialysis
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="dialysisType"
              disabled
              label="Dialysis Type"
            />
          </div>
          <!-- <div class="col-2">
          <div class="fieldName">
            Dialysis Type
          </div>
          <input
            v-model="dialysisType"
            class="inputDisplay"
            disabled
          >
        </div>  -->

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisAccessMode"
              disabled
              label="Dialysis Access Mode"
            />
          </div>

          <!-- <div class="col-2">
          <div class="fieldName">
            Dialysis Access Mode
          </div>
          <input
            v-model="dialysisAccessMode"
            class="inputDisplay"
            disabled
          >
        </div> -->

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisLocation"
              disabled
              label="Dialysis Location"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="otherDialysisLocation"
              disabled
              label="Other Dialysis Location"
            />
          </div>
   
          <div class="col-2">
            <ADSTextInput
              v-model="dialysisProvider"
              disabled
              label="Dialysis Provider"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="dialysisStartDate"
              disabled
              label="Dialysis Start Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="dialysisEndDate"
              disabled
              label="Dialysis End Date"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "DialysisSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialysisType: this.getDialysisType( this.patientBundle ),
      dialysisAccessMode: this.getDialysisAccessMode( this.patientBundle ),
      dialysisLocation: this.getDialysisLocation( this.patientBundle ),
      otherDialysisLocation: this.getOtherDialysisLocation( this.patientBundle ),
      dialysisProvider: this.getDialysisProvider( this.patientBundle ),
      dialysisStartDate: this.getDialysisStartDate( this.patientBundle ),
      dialysisEndDate: this.getDialysisEndDate( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getDialysisType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#177' ) ) ;
      if( dialysisType && dialysisType[ 0 ] ) {
        return _.get( dialysisType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getDialysisAccessMode( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisAccessMode = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#178' ) ) ;
      if( dialysisAccessMode && dialysisAccessMode[ 0 ] ) {
        return _.get( dialysisAccessMode[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getDialysisLocation( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisLocation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#179' ) ) ;
      if( dialysisLocation && dialysisLocation[ 0 ] ) {
        return _.get( dialysisLocation[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOtherDialysisLocation( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisLocation = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#180' ) ) ;
      if( dialysisLocation && dialysisLocation[ 0 ] ) {
        return _.get( dialysisLocation[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getDialysisProvider( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisProvider = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#207' ) ) ;
      if( dialysisProvider && dialysisProvider[ 0 ] ) {
        return _.get( dialysisProvider[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getDialysisStartDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#330' ) ) ;
      if( dialysisStartDate && dialysisStartDate[ 0 ] ) {
        return _.get( dialysisStartDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getDialysisEndDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let dialysisEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#331' ) ) ;
      if( dialysisEndDate && dialysisEndDate[ 0 ] ) {
        return _.get( dialysisEndDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 330px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 330px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

</style>
